import React from 'react';

const differentiators = [
  {
    title: "AI-First Approach",
    description: "We don't just automate processes, we add intelligence to every aspect of your business operations.",
    image: "/images/ai_strategy.png"
  },
  {
    title: "End-to-End Delivery",
    description: "From strategy to implementation to ongoing support, we handle the complete journey.",
    image: "/images/packaging.png"
  },
  {
    title: "Enterprise-Grade Security",
    description: "Built-in governance, compliance, and security across all services and implementations.",
    image: "/images/cyber-security.png"
  },
  {
    title: "Startup Speed, Enterprise Quality",
    description: "We combine rapid prototyping with mature engineering practices and governance.",
    image: "/images/connection.png"
  }
];

function WhoAreWe() {
  return (
    <div className="bg-white py-24 px-6">
      <div className="max-w-6xl mx-auto">
        
        {/* Header Section */}
        <div className="text-center mb-20">
          <h2 className="text-4xl md:text-5xl font-extrabold text-[#17091a] mb-6">
            What Sets Us <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#952877] to-[#592aa7]">Apart</span>
          </h2>
          <div className="w-24 h-1.5 bg-gradient-to-r from-[#952877] to-[#592aa7] mx-auto rounded-full mb-6"></div>
          <p className="text-gray-600 text-xl max-w-2xl mx-auto leading-relaxed">
            Our unique approach combines cutting-edge technology with proven business strategies.
          </p>
        </div>

        {/* Grid Section */}
        <div className="grid md:grid-cols-2 gap-10">
          {differentiators.map((item, index) => (
            <div key={index} className="group relative">
              {/* Animated Background Gradient (Visible on Hover) */}
              <div className="absolute inset-0 bg-gradient-to-r from-[#952877]/5 to-[#592aa7]/5 rounded-3xl transform group-hover:scale-105 transition-transform duration-500 ease-out"></div>
              
              <div className="relative p-8 bg-white border border-gray-100 rounded-3xl shadow-sm group-hover:shadow-xl group-hover:border-transparent transition-all duration-300 h-full flex flex-col md:flex-row gap-6">
                
                {/* Icon Circle */}
                <div className="w-20 h-20 rounded-2xl bg-gradient-to-br from-[#952877] to-[#592aa7] p-0.5 flex-shrink-0 shadow-lg shadow-purple-200">
                  <div className="w-full h-full bg-white rounded-[14px] flex items-center justify-center overflow-hidden">
                    <img 
                      src={item.image}
                      className="w-12 h-12 object-contain group-hover:scale-110 transition-transform duration-300"
                      alt={item.title}
                    />
                  </div>
                </div>

                {/* Text */}
                <div className="flex flex-col">
                  <h3 className="text-2xl font-bold text-[#17091a] mb-3 group-hover:text-[#952877] transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed text-base">
                    {item.description}
                  </p>
                  
                  {/* Subtle "Learn More" or Arrow indicator */}

                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default WhoAreWe;